import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    try {
      const context = new (window.AudioContext || window.webkitAudioContext)()
      const now = context.currentTime
      const gain = context.createGain()
      gain.gain.setValueAtTime(0.15, now)
      gain.gain.exponentialRampToValueAtTime(0.001, now + 0.6)
      gain.connect(context.destination)
      const first = context.createOscillator()
      first.frequency.value = 880
      first.connect(gain)
      first.start(now)
      first.stop(now + 0.15)
      const second = context.createOscillator()
      second.frequency.value = 1318
      second.connect(gain)
      second.start(now + 0.15)
      second.stop(now + 0.6)
    } catch {
      return
    }
  }
}
